import React from "react";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { Sparkles, X } from "lucide-react";
const DRAWER_ABOVE_OVERLAY_CLASSES = "!z-[999999999]";

const EnrichmentEnterpriseModal = ({ isOpen, onClose, message = null }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName={DRAWER_ABOVE_OVERLAY_CLASSES}
      className="!z-[999999999] p-6"
    >
      <div className="flex justify-end w-full">
        <button
          type="button"
          className="p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors cursor-pointer"
          aria-label="Close"
          onClick={onClose}
        >
          <X size={20} className="text-gray-500" />
        </button>
      </div>

      <div className="flex flex-col items-center text-center gap-4 px-2 pb-2">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-secondary-light-transparent border border-secondary/60 shadow-xs">
          <Sparkles className="h-7 w-7 text-secondary" />
        </div>

        <div className="flex flex-col gap-1.5">
          <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100">
            {message ? "You've reached your trial limit" : "Upgrade to unlock contact enrichment"}
          </h3>
          <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed max-w-sm">
            {message ||
              "Verified emails and phone numbers are available on paid plans. You can keep prospecting on your trial; contact our team to upgrade your account."}
          </p>
        </div>

        <div className="flex gap-3 w-full mt-2">
          <SecondaryButton
            title="Maybe later"
            className="w-full text-xs font-semibold"
            onClick={onClose}
          />
          <PrimaryButton
            startContent={false}
            className="w-full text-xs font-semibold cursor-pointer"
            onClick={() => window.open("https://salesworx.ai/salesworx-contact/", "_blank", "noopener,noreferrer")}
          >
            Contact Sales
          </PrimaryButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default EnrichmentEnterpriseModal;
